module.exports = __webpack_public_path__ + "img/tla.9c4d5399.webp";